import healthCheckSlice from "../slices/healthCheckSlice";

export const {
  TriggerHealthCheck,
  FinishHealthCheck,
  TriggerPhishboxHealthCheck,
  FinishPhishboxHealthCheck,
  TriggerHunterboxHealthCheck,
  FinishHunterboxHealthCheck,
  SuccessCoreResponsibles,
  FailureCoreResponsibles,
  SuccessInternetStatus,
  FailureInternetStatus,
  SuccessVpnStatus,
  FailureVpnStatus,
  SuccessAnalyserStatus,
  FailureAnalyserStatus,
  SuccessReporterStatus,
  FailureReporterStatus,
  SuccessBrokerStatus,
  FailureBrokerStatus,
  SuccessDiskStatus,
  FailureDiskStatus,
  SuccessFtiStatus,
  FailureFtiStatus,
  SuccessMlStatus,
  FailureMlStatus,
  SuccessCdrStatus,
  FailureCdrStatus,
  SuccessPhishStatus,
  FailurePhishStatus,
  SuccessRabbitStatus,
  FailureRabbitStatus,
  SuccessZsearchStatus,
  FailureZsearchStatus,
  SuccessMongoStatus,
  FailureMongoStatus,
  SuccessPhishboxInternetStatus,
  FailurePhishboxInternetStatus,
  SuccessAgenterStatus,
  FailureAgenterStatus,
} = healthCheckSlice.actions;
